
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SurveyResultMeta } from '../../../backend/backendapi';

@Component
export default class GroupResultsModalFooter extends Vue {
  @Prop({ required: true })
  results!: SurveyResultMeta[];

  get passedCount(): number {
    return this.results.filter(e => e.passed).length;
  }

  get passedPercent(): number {
    const percent = this.passedCount / this.totalCount * 100;
    return Math.round(percent * 10) / 10;
  }

  get passedPercentColor(): string {
    if (this.passedPercent >= 100) {
      return 'var(--green)';
    } else if (this.passedPercent >= 90) {
      return 'var(--yellow)';
    } else if (this.passedPercent >= 80) {
      return 'var(--orange)';
    } else {
      return 'var(--red)';
    }
  }

  get totalCount(): number {
    return this.results.length;
  }

  get validCount(): number {
    return this.results.filter(e => e.passed && e.validInPeriod).length;
  }
}
